var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{class:_vm.b()},[_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.period.period,'MMMM YYYY')))]),_c('td',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.period.balance,undefined, { precision: 0 })))]),_c('td',{style:({ color: _vm.qualificationColor })},[_vm._v(_vm._s(_vm._f("formatQualification")(_vm.period.qualification)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }